import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import * as commonData from "../../../Common";
import AsyncReactSelect from "react-select/async";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import "rsuite/dist/rsuite.min.css";
import CustomOption from "../../CustomOption";
import ReactSelectNew from "../../React_Select/ReactSelectNew";

function CustomFilter(props, ref) {
  const param = useParams();
  const [text, setText] = useState("");
  const options = props.colDef.options;
  const [searchfiled, setSearchField] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [data, setData] = useState({});
  const [dataLocal, setDataLocal] = useState({});
  const [state, setState] = useState({
    attributeSet: "",
    users: [],
  });
  const [accountManager, setAccountManager] = useState([]);
  const [salesManager, setSalesManager] = useState([]);
  const [tseOwner, setTseOwner] = useState([]);
  const [customerType, setCustomerType] = useState([]);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
     setData({});
  }, [props.filterName, props.resetFilter]);
  
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        attributeSet: props.attributeset,
      };
    });
  }, [props.attributeset]);

  useEffect(() => {
    if (props.resetFilter) {
      setData({});
    }
    let attribute_set_key = param.attribute_set_key;
    let getOptionsData = localStorage.getItem("filter");
    let dataTransform = JSON.parse(getOptionsData);
    if (param.hasOwnProperty("id")) {
      return;
    }
    setTimeout(() => {
      if (
        dataTransform?.[attribute_set_key] &&
        Object.keys(JSON.parse(dataTransform?.[attribute_set_key])).length >
        0 &&
        commonData.IsJsonString(dataTransform?.[attribute_set_key])
      ) {
        setDataLocal(JSON.parse(dataTransform?.[attribute_set_key]));
      }
    });
  }, []);

  useEffect(() => {
    const id = setTimeout(() => {
      if (Object.keys(data).length > 0 || text.trim() !== "") {
        props.colDef.filterParams.filter(props, data || text);
      }
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [text, data]);

  useEffect(() => {
    if (props.users) {
      let getUsersVal = Object.keys(props.users)
        .filter((it) => props.users[it]?.is_active == 1)
        .map((ite) => ({
          label: props.users[ite].name,
          value: props.users[ite].user_uuid,
          profile_image: props.users[ite].profile_image,
        }));
      setState((state) => {
        return {
          ...state,
          users: getUsersVal,
        };
      });
    }
  }, [props.users]);
  useEffect(() => {
    setData({});
  }, [props]);

  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return text !== "";
      },
      doesFilterPass(params) {
        return params.data.status === text;
      },
    };
  });
  const convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };

  const chechValueObject = (data, dataLocal) => {
    if (data && Object.keys(data || {}).length > 0) {
      return data;
    } else if (dataLocal && Object.keys(dataLocal || {}).length > 0) {
      return dataLocal;
    }
  };

  const dateRangePicker = (evt, field, type) => {
    if (evt && Array.isArray(evt)) {
      if (type === "timestamp") {
        const dates = evt.map((ev) =>
          Math.floor(new Date(ev).getTime() / 1000)
        );
        setData((state) => {
          return {
            [field]: dates,
          };
        });
      } else {
        const daterange = evt.map((item) => convertDateFormat(item));
        setData((state) => {
          return {
            [field]: daterange,
          };
        });
      }
    } else {
      let newdata = {};

      newdata = {
        ...newdata,
        [field]: [],
      };
      setData((state) => {
        return {
          ...state,
          ...newdata,
        };
      });
    }
  };

  const statusChangehandler = (evt, column = null) => {
    // Determine the field name and value
    const fieldName = evt?.target?.name || column;
    const fieldValue = Array.isArray(evt) // Handle arrays
      ? evt.map((item) => (item?.value ? item.value : item)) // Map array items to their values
      : evt?.target?.value || evt?.value || ""; // Handle non-array values

    // Update the `data` state
    setData((state) => ({
      ...state,
      [fieldName]: fieldValue, // For arrays, this will store the array
    }));

    // Optionally update the `dataLocal` state
    setDataLocal((state) => ({
      ...state,
      [fieldName]: fieldValue,
    }));

    // Update other state as necessary
    setState((state) => ({
      ...state,
      attributeSet: fieldValue, // Update attributeSet with the value
    }));
  };

  useEffect(() => {
    setFilterData(props.colDef);

    if (Array.isArray(filterData.options)) {
      setSearchField(filterData.options || []);
    } else {
      const data =
        filterData.options &&
        Object?.keys(filterData.options).map((item) => {
          return {
            name:
              filterData.options[item].name || filterData.options[item].title,
            user_uuid:
              filterData.options[item].user_uuid || filterData.options[item].id,
            email: filterData.options[item].email,
          };
        });
      setSearchField(data || []);
    }
  }, [filterData]);

  useEffect(() => {
    if (props.colDef?.attribute_type === "account_manager") {
      (async () => {
        let response = await fetch(props.colDef?.api_url);
        const rdata = await response.json();

        const account_manager = rdata?.data.map((item) => ({
          label: item?.name,
          value: item?.user_uuid ? item?.user_uuid : item?.id,
        }));
        setAccountManager(account_manager);
      })();
    }
    if (props.colDef?.attribute_type === "sales_manager") {
      (async () => {
        let response = await fetch(props.colDef?.api_url);
        const rdata = await response.json();

        const account_manager = rdata?.data.map((item) => ({
          label: item?.name,
          value: item?.user_uuid ? item?.user_uuid : item?.id,
        }));
        setSalesManager(account_manager);
      })();
    }
    if (props.colDef?.attribute_type === "tse_owner") {
      (async () => {
        let response = await fetch(props.colDef?.api_url);
        const rdata = await response.json();

        const account_manager = rdata?.data.map((item) => ({
          label: item?.name,
          value: item?.user_uuid ? item?.user_uuid : item?.id,
        }));
        setTseOwner(account_manager);
      })();
    }

    if (props.colDef?.attribute_type === "customer_type") {
      (async () => {
        let response = await fetch(props.colDef?.api_url);
        const rdata = await response.json();

        const responsedat = Object.keys(rdata).map((key) => ({
          label: rdata[key]?.customer_type,
          value: key,
        }));
        setCustomerType(responsedat);
      })();
    }
  }, [props]);

  const companyAsyncCall = async (evt, api) => {
    // const getOptionsData = localStorage.getItem("filter");
    // const parsedData = JSON.parse(getOptionsData);\

    const filterData = JSON.parse(localStorage.getItem("filter") || "{}");
    let rawCompanies = [];
    
    if (filterData[props.colDef.attribute_set_key]) {
      const parsedSet = JSON.parse(filterData[props.colDef.attribute_set_key]);
      rawCompanies = parsedSet.company_name || [];
    }
    

    const localCompanyNames = rawCompanies.map(item => (item && item.value !== undefined ? item.value : item));


    const requestBody = {
      search: evt || "",
      company_name: localCompanyNames,
    };
  
    return new Promise(async (resolve, reject) => {
      try {
        const fetchdata = await fetch(api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
  
        const redata = await fetchdata.json();
  
        if (redata.code === 200) {
          const companyList = redata.data.map((item) => ({
            label: commonData.firstUpper(item.value),
            value: item.id,
          }));
          setCompanies(companyList);
          resolve(companyList);
        } else {
          reject(new Error(`API error: ${redata.code}`));
        }
      } catch (error) {
        console.error("API fetch error:", error);
        reject(error);
      }
    });
  };
  
  const filterOptions = (evt) => {
    const { value } = evt.target;
    try {
      const options = filterData.options;
      let data;
      if (Array.isArray(filterData?.options)) {
        data = filterData?.options?.filter((item) =>
          item?.name.toLowerCase().includes(value.toString())
        );
      } else {
        data = Object.keys(filterData.options)
          .filter((item) =>
            filterData?.options[item]?.name
              .toLowerCase()
              .includes(value.toString())
          )
          .map((ite) => ({
            name: filterData.options[ite].name,
            user_uuid: filterData.options[ite].user_uuid,
            email: filterData.options[ite].email,
          }));
      }
      setSearchField(data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      wordBreak: "break-all",
    }),
    control: (styles, state) => {
      return {
        ...styles,
        fontSize: "12px",
        textAlign: "left",
        boxShadow: "none",
        height: state.selectProps?.className === "isLarge" && 100,
        overflowY: "auto",
      };
    },
    menu: () => {
      return {
        boxShadow: "none",
        marginTop: "10px",
      };
    },
    menuList: (style) => {
      return {
        ...style,
        maxHeight: props.className === "children" ? 180 : 300,
      };
    },
  };
  if (filterData.field === "customer_tattle_uuid") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          value={data[filterData?.field]}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (
    filterData?.attribute_type === "date" ||
    filterData?.attribute_type === "start_date" ||
    filterData?.attribute_type === "end_date" ||
    filterData?.attribute_type === "go_live_date" ||
    filterData?.attribute_type === "timestamp"
  ) {
    let val;
    if (filterData?.attribute_type === "timestamp") {

      if (data[filterData?.field]) {
        val = data?.[filterData?.field]?.map((ev) => new Date(ev));
      } else {
        val = dataLocal?.range?.[filterData?.field]?.map(
          (ev) => new Date(ev * 1000)
        );


      }
    } else {

      if (data[filterData?.field]) {
        val = Array.isArray(data?.[filterData?.field])
          ? data?.[filterData?.field].map((ev) => new Date(ev))
          : [];
      } else {
        val = dataLocal?.range?.[filterData?.field]?.map((ev) => new Date(ev));
      }
    }

    return (
      <div className="filterdiv_parent">
        <DateRangePicker
          className="custom-date-range-picker"
          onChange={(evt) =>
            dateRangePicker(evt, filterData.field, filterData?.attribute_type)
          }
          value={val || null}
          onClean={(evt) =>
            dateRangePicker(evt, filterData.field, filterData?.attribute_type)
          }
          showOneCalendar
        />
        {/* <input
          type="date"
          value={data[filterData.field]}
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }

  if (filterData.field === "created_timestamp") {
    return (
      <div className="filterdiv_parent">
        <DateRangePicker
          className="custom-date-range-picker"
          onChange={(evt) => dateRangePicker(evt, "created_date")}
          onClean={(evt) => dateRangePicker(evt, "created_date")}
          showOneCalendar
          value={
            data.hasOwnProperty("created_date") && data["created_date"] != ""
              ? [
                new Date(data?.["created_date"]?.[0]),
                new Date(data?.["created_date"]?.[1]),
              ]
              : [new Date()]
          }
        />
        {/* <input
          type="date"
          value={data[filterData.field]}
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }
  if (filterData?.attribute_type === "cc") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "status") {
    return (
      <ReactSelectNew
        statusChangehandler={statusChangehandler}
        field={filterData?.field}
        data={chechValueObject(data, dataLocal)}
        options={searchfiled}
      />
    );
  }
  if (filterData.attribute_type === "account_manager") {
    let newoptions = [];
    if (filterData?.options?.data) {
      newoptions = filterData?.options?.data.map((it) => ({
        label: it?.name,
        value: it?.user_uuid,
      }));
    }
    return (
      <div className="filterdiv_parent" style={{ height: "200px" }}>
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={newoptions}
        />
        {/* 
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }
  if (filterData.attribute_type === "sales_manager") {
    let newoptions = [];
    if (filterData?.options?.data) {
      newoptions = filterData?.options?.data.map((it) => ({
        label: it?.name,
        value: it?.user_uuid,
      }));
    }
    return (
      <div className="filterdiv_parent" style={{ height: "200px" }}>
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={newoptions}
        />
        {/* 
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }
  if (filterData.attribute_type === "tse_owner") {
    let newoptions = [];
    if (filterData?.options?.data) {
      newoptions = filterData?.options?.data.map((it) => ({
        label: it?.name,
        value: it?.user_uuid,
      }));
    }
    return (
      <div className="filterdiv_parent" style={{ height: "200px" }}>
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={newoptions}
        />
        {/* 
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }
  if (filterData.attribute_type === "customer_type") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={customerType}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "number") {
    return (
      <div className="filterdiv_parent">
        <input
          type="number"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "toggle") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "customer") {
    let val;
    if (data[filterData?.field]) {
      val = data[filterData?.field];
    } else {
      val = dataLocal[filterData?.field];
    }
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          value={val}
          placeholder="Type Email"
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (
    filterData.attribute_type === "text" ||
    filterData.attribute_type === "customer_tattle_uuid" ||
    filterData.attribute_type === "url"
  ) {
    let val;
    if (data[filterData?.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData?.field];
    }

    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          value={val}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "textarea") {
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "multi-select") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={searchfiled}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "category") {
    return (
      <ReactSelectNew
        statusChangehandler={statusChangehandler}
        field={filterData?.field}
        data={chechValueObject(data, dataLocal)}
        options={searchfiled}
      />
    );
  }
  if (filterData.attribute_type === "board") {
    let val;
    const defaultvalue = searchfiled
      .filter((item) => item.customer_tattle_uuid == state.attributeSet)
      .map((ii) => ({ label: ii.title, value: ii.customer_tattle_uuid }));
    return (
      <div className="filterdiv_parent">
        <ReactSelect
          styles={customStyles}
          isMulti={false}
          menuIsOpen={true}
          value={defaultvalue}
          onChange={(evt) => statusChangehandler(evt, filterData.field)}
          options={searchfiled?.map((item) => ({
            label: item.title,
            value: item.customer_tattle_uuid,
          }))}
        />
      </div>
    );
  }

  if (
    filterData.attribute_type === "api" ||
    filterData.attribute_type === "release"
  ) {
    let options;
    if (props.colDef.attribute_set_key === "fd") {
      options = Array.isArray(searchfiled)
        ? searchfiled.map(it => ({ id: String(it.id), value: it.value }))
        : [];
    } else {
      options = Array.isArray(searchfiled) ? searchfiled : [];
    }
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={options}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "product") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={searchfiled}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "monitoring") {
    const app_token = commonData.getCommonData().app_token;
    const usePrase = JSON.parse(commonData.getCommonData().user_details);
    const ing = usePrase.find((item) => item.app_token == app_token);
    const datafil = searchfiled
      .filter((ii) => (ii.user_uuid == ing.user_uuid ? ii : ""))
      .map((io) => {
        return { label: io.name, value: io.user_uuid };
      });

    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={state.users}
        />
      </div>
    );
  }

  if (filterData.attribute_type === "assign_to") {
    const app_token = commonData.getCommonData().app_token;
    const usePrase = JSON.parse(commonData.getCommonData().user_details);
    const ing = usePrase.find((item) => item.app_token == app_token);
    const datafil = searchfiled
      .filter((ii) => (ii.user_uuid == ing.user_uuid ? ii : ""))
      .map((io) => {
        return { label: io.name, value: io.user_uuid };
      });

    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={state.users}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "people") {
    const app_token = commonData.getCommonData().app_token;
    const usePrase = JSON.parse(commonData.getCommonData().user_details);
    const ing = usePrase.find((item) => item.app_token == app_token);
    const datafil = searchfiled
      .filter((ii) => (ii.user_uuid == ing.user_uuid ? ii : ""))
      .map((io) => {
        return { label: io.name, value: io.user_uuid };
      });

    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={state?.users}
        />
      </div>
    );
  }

  if (filterData.attribute_type === "reporter") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={state?.users}
        />
      </div>
    );
  }
  if (
    filterData?.attribute_type === "project" ||
    filterData?.attribute_type === "external_api"
  ) {
    let val;

    if (data[filterData?.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          name={filterData.field}
          value={val || ""}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (filterData?.field === "completed") {
    return (
      <ReactSelectNew
        statusChangehandler={statusChangehandler}
        field={filterData?.field}
        data={chechValueObject(data, dataLocal)}
        options={searchfiled}
      />
    );
  }
  if (filterData?.attribute_type === "company_name") {
    return (
      <div className="filterdiv_parent company_filter">
        {/* <AsyncReactSelect
          cacheOptions
          defaultOptions
          menuIsOpen
          value={val}
          loadOptions={(evt) => companyAsyncCall(evt, filterData.api_url)}
          isClearable
          isMulti
          onChange={(evt) => statusChangehandler(evt, "company_name")}
        /> */}

        <ReactSelectNew
          getPeoplesCall={companyAsyncCall}
          field={filterData?.field}
          type="api"
          statusChangehandler={statusChangehandler}
          apiUrl={filterData.api_url}
          isAsync={true}
          data={chechValueObject(data, dataLocal)}
          serverSearch={true}
          options={companies}
        />
        {/* <input
          type="text"
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        /> */}
      </div>
    );
  }
  if (filterData?.attribute_type === "name") {
    let val;
    if (data[filterData.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          placeholder="Type Name"
          value={val}
          name={"customer_name"}
          onChange={(evt) => statusChangehandler(evt, "customer_name")}
          className="form-control"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "age") {
    let val;
    if (data[filterData.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          placeholder="Show age  less than"
          value={val}
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "last_update_since") {
    let val;
    if (data[filterData.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }
    return (
      <div className="filterdiv_parent">
        <input
          type="text"
          placeholder="Show last update less than"
          value={val}
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
          autoComplete="off"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "priority") {
    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={searchfiled}
        />
      </div>
    );
  }
  if (filterData.attribute_type === "effort") {
    let val;
    if (data[filterData.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }
    /*let options;
    if (filterData.options) {
      options = Object.keys(filterData.options).map((item) => ({
        label: filterData.options[item]?.name,
        value: item,
      }));
    }*/

    return (
      <div className="filterdiv_parent">
        {/* <ReactSelect
          styles={customStyles}
          isMulti={true}
          value={options.filter((it) =>
            data[filterData.custom_field]?.[filterData.field]?.includes(
              it.value
            )
          )}
          menuIsOpen={true}
          onChange={(evt) => statusChangehandler(evt, filterData.custom_field)}
          options={options}
        />*/}
        <input
          type="text"
          value={val}
          name={filterData.field}
          onChange={(evt) => statusChangehandler(evt)}
          className="form-control"
        />
      </div>
    );
  }
  if (filterData.attribute_type === "select") {

    let val;
    if (data[filterData.field]) {
      val = data[filterData.field];
    } else {
      val = dataLocal[filterData.field];
    }

    return (
      <div className="filterdiv_parent">
        <ReactSelectNew
          statusChangehandler={statusChangehandler}
          field={filterData?.field}
          data={chechValueObject(data, dataLocal)}
          options={searchfiled}
        />
      </div>
    );
  }
}

export default memo(forwardRef(CustomFilter));
